import DOMPurify from "dompurify";

/**
 * Treść z RichTextEditora (uwagi na karcie, wpisy w historii kontaktu).
 *
 * Starsze wpisy są czystym tekstem — te renderujemy po staremu z pre-wrap,
 * a HTML tylko po przejściu przez DOMPurify (ta sama biała lista tagów,
 * którą realnie produkuje edytor).
 */

const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "ul", "ol", "li", "img", "h1", "h2", "h3"],
  ALLOWED_ATTR: ["src", "alt", "width", "height", "start"],
};

function isHtmlContent(content: string) {
  return content.trimStart().startsWith("<");
}

export function LeadRichText({
  content,
  className = "",
}: {
  content: string;
  className?: string;
}) {
  if (!isHtmlContent(content)) {
    return <p className={`whitespace-pre-wrap ${className}`}>{content}</p>;
  }
  return (
    <div
      className={`rich-text-content break-words ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, SANITIZE_OPTIONS) }}
    />
  );
}
